import PropTypes from "prop-types"

import Column from "../../../common/components/Column"
import ConditionalPurpleLinearProgress from "../../../common/components/ConditionalLinearProgress"
import AdminLiquidSurface from "./AdminLiquidSurface"

export default function AdminLoadingPaper({ isLoading, children }) {
  return (
    <Column sx={{ width: "100%", alignItems: "center" }}>
      <ConditionalPurpleLinearProgress visible={isLoading} />
      <AdminLiquidSurface
        variant="card"
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          p: { xs: 2.5, sm: 3 },
        }}
      >
        {children}
      </AdminLiquidSurface>
    </Column>
  )
}

AdminLoadingPaper.propTypes = {
  isLoading: PropTypes.bool,
  children: PropTypes.any,
}
